import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { useEffect } from 'react'

import DeskIllustration from '@ui/assets/illustrations/desk.svg'
import { useMediaQuery } from '@uidotdev/usehooks'

const welcomeMessages = [
  `You're looking sharp today!`,
  `Looking sharp! Let's get things rolling.`,
  `Hello, amazing human!`,
  `Let's create some magic!`,
  `You're a star!`,
  `You’re on fire today!`,
  `You’ve got this! Let's dive in.`,
]

type SuccessFormProps = {
  message?: string
  transitionFromSuccessCallback: (() => void) | null
}

export const SuccessForm = ({ message, transitionFromSuccessCallback }: SuccessFormProps) => {
  const isSmallDevice = useMediaQuery('only screen and (max-width : 768px)')

  const randomMessage = welcomeMessages[Math.floor(Math.random() * welcomeMessages.length)]

  useEffect(() => {
    if (!isSmallDevice && transitionFromSuccessCallback) {
      // only transition away if we're on a large device
      transitionFromSuccessCallback()
    }
  }, [isSmallDevice])

  return (
    <div>
      <div className="block md:hidden">
        <p className="py-2 text-center text-xl">Your account has been verified!!</p>
        <div className="flex flex-col gap-1 rounded-md bg-[#EFF2F3] p-4 text-center">
          <p className="text-xl">Log in on desktop</p>
          <p className="text-sm">From your desktop, open the link we sent to your email.</p>
          <img src={DeskIllustration} alt="Desk" className="size-48 mx-auto" />
        </div>
      </div>
      <div className="hidden items-center justify-center pt-12 text-center text-green-600 md:flex">
        <CheckCircleIcon className="mr-4 h-14 w-14" />
        <h1 className="text-lg leading-tight tracking-tight">{message || randomMessage}</h1>
      </div>
    </div>
  )
}
